import { Link } from "react-router-dom";

interface Props {
  eyebrow?: string;
  title: string;
  desc?: string;
  linkText?: string;
  linkTo?: string;
  align?: "left" | "center";
}

export default function SectionHeader({
  eyebrow,
  title,
  desc,
  linkText,
  linkTo,
  align = "left",
}: Props) {
  return (
    <div
      className={`mb-6 md:mb-8 ${
        align === "center" ? "flex flex-col items-center text-center" : ""
      }`}
    >
      {eyebrow && (
        <span className="mb-2 inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
          <i className="ri-flashlight-fill" aria-hidden="true"></i>
          {eyebrow}
        </span>
      )}
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-display text-2xl text-foreground-950 md:text-3xl">{title}</h2>
          {desc && (
            <p className={`mt-2 max-w-2xl text-sm text-foreground-600`}>{desc}</p>
          )}
        </div>
        {linkText && linkTo && (
          <Link
            to={linkTo}
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-secondary-100 px-4 py-2 text-sm font-medium text-secondary-900 transition-colors hover:bg-secondary-500 hover:text-background-50"
          >
            {linkText}
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        )}
      </div>
    </div>
  );
}